type AuthState = {
  user: unknown;
  mustChangePassword: boolean;
};

export function clearAuthState(state: AuthState) {
  state.user = null;
  state.mustChangePassword = false;
}
